import $ from "jquery";
import DataTables from "datatables.net";
import "datatables.net-select";

// Attach DataTables plugin to jQuery in CommonJS environment. When loaded in
// the browser it attaches itself automatically.
if (!$.fn.DataTable) {
  DataTables();
}

// Attach jQuery to window for Bootstrap
window.jQuery = window.$ = $;



// WEBPACK FOOTER //
// ./src/include/jquery.js